let elements = {
  // playOnEnd: true,
  autoCheck: false,
  restoreColor: true, // cannot be used with blockWrongColor
  audio: {
    negative: 'games/page023_game1/audio/false.mp3',
    // positive: 'games/page023_game1/audio/true.mp3',
    click: 'games/page023_game1/audio/click.mp3',
  },
  image: {
    trImage: 'games/page023_game1/img/img_t2.webp',
    srcImage: 'games/page023_game1/img/img_o2.png',
    srcMask: 'games/page023_game1/img/img_m.png',
    width: 1920,
    height: 1080,
    // if colors is array of objects (not a single object), blockWrongColor must be false (default)
    colors: [
      {
        1: '#000000',
        2: '#f9ed4a',
        3: '#f9ed4a',
        4: '#ffffff',
      },
      {
        1: '#000000',
        2: '#f9ed4a',
        3: '#ffffff',
        4: '#f9ed4a',
      },
      {
        1: '#000000',
        2: '#ffffff',
        3: '#f9ed4a',
        4: '#f9ed4a',
      },
      // {
      //   1: '#000000',
      //   2: '#f9ed4a',
      //   3: '#ffffff',
      //   4: '#ffffff',
      //   5: '#f9ed4a',
      //   6: '#ffffff',
      //   7: '#f9ed4a',
      //   8: '#f9ed4a',
      //   9: '#f9ed4a',
      //   10: '#ffffff',
      //   11: '#f9ed4a',
      //   12: '#ffffff',
      //   13: '#f9ed4a',
      //   14: '#ffffff',
      // },
      // {
      //   1: '#000000',
      //   2: '#f9ed4a',
      //   3: '#f9ed4a',
      //   4: '#f9ed4a',
      //   5: '#f9ed4a',
      //   6: '#f9ed4a',
      //   7: '#ffffff',
      //   8: '#ffffff',
      //   9: '#f9ed4a',
      //   10: '#f9ed4a',
      //   11: '#f9ed4a',
      //   12: '#f9ed4a',
      //   13: '#ffffff',
      //   14: '#f9ed4a',
      // },
      // {
      //   1: '#000000',
      //   2: '#ffffff',
      //   3: '#f9ed4a',
      //   4: '#f9ed4a',
      //   5: '#ffffff',
      //   6: '#f9ed4a',
      //   7: '#f9ed4a',
      //   8: '#f9ed4a',
      //   9: '#ffffff',
      //   10: '#f9ed4a',
      //   11: '#ffffff',
      //   12: '#f9ed4a',
      //   13: '#f9ed4a',
      //   14: '#f9ed4a',
      // },
    ],
    cssStyle: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '1080px',
      width: '1920px',
    },
  },
  palette: {
    colors: [
      // {
      //   audioId: 'a1',
      //   val: '#f9ed4a',
      //   audio: 'games/page023_game1/audio/34_two.mp3',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '54.1%',
      //     top: '71%',
      //     width: '6.2%',
      //     height: '17.3%',
      //     transform: 'rotate(0deg)',
      //     'border-radius': '9%',
      //     // 'background-color': 'rgba(83,187,63,0.4)',
      //   },
      // },
      {
        audioId: 'a1',
        val: '#f9ed4a', // yellow
        waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
        clicked: { src: 'games/page033_game1/img/yellow_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '50.5%',
          top: '76.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
    ],
    mbPaletteAudioItemData: [
      {
        id: 'a1',
        src: 'games/page023_game1/audio/34_two.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page023_game1/img/audioOn.png', iconOff: 'games/page023_game1/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 11,
          x: 239,
        },
        unit: 'px',
      },
    ],
  },
};

export default elements;
